import React from 'react';
import {t} from 'common/utils/translation-util';
import './index.scss';
import PropTypes from 'prop-types';

const StoryboardError = (props) => {
  // More human readable error messages
  let errorTitle = '';
  let errorBody = '';
  const supportText = t(
    'For questions, please contact <a href="mailto:support@luciddg.com">Customer Support</a>.',
  );

  if (props && props.error && props.error.message) {
    switch (props.error.message.toUpperCase()) {
      case 'FORBIDDEN':
        errorTitle = t("Sorry, this page isn't available.");
        errorBody = t(
          'The link you followed may be broken, or the page may have been removed.',
        );
        break;
      case 'FAILED TO FETCH':
        errorTitle = t('Oops! Something went wrong.');
        errorBody = t('Please wait a moment and try again.');
        break;
      case 'NETWORK ERROR':
        errorTitle = t('Stay tuned.');
        errorBody = t(
          'A network problem is preventing this page from loading. Please wait a moment and try again.',
        );
        break;
      default:
        errorTitle = t('Oops! Something went wrong.');
        errorBody = t('Something unexpected occured.');
    }
  }
  return errorTitle !== '' ? (
    <section className={'StoryboardError'}>
      <h1>{errorTitle}</h1>
      <div>
        <p>
          {errorBody} <span dangerouslySetInnerHTML={{__html: supportText}} />
        </p>
      </div>
    </section>
  ) : null;
};

StoryboardError.propTypes = {
  error: PropTypes.shape({message: PropTypes.string}),
};

export default StoryboardError;
